import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/required-uuid-string.js';
export const setLeafLinkWebhookSecretArgsSchema = z.object({
    leafLinkIntegrationId: requiredUuidString('LeafLink company is required.', 'Invalid LeafLink company.'),
    secret: z
        .string()
        .trim()
        .min(16, 'Signing secret must be at least 16 characters.')
        .max(256, 'Signing secret must be at most 256 characters.'),
});
//# sourceMappingURL=set-leaflink-webhook-secret-args-schema.js.map